// Refcounted background scroll lock shared by Dialog and Drawer, so a stacked
// overlay (e.g. a confirm dialog above a drawer) doesn't unlock the page when
// the inner one closes. The class is styled in app.css.

let locks = 0;

/** Acquire the scroll lock; returns a release function (idempotent per call). */
export function lockScroll(): () => void {
  locks += 1;
  document.documentElement.classList.add("dialog-open");
  let released = false;
  return () => {
    if (released) return;
    released = true;
    locks = Math.max(0, locks - 1);
    if (locks === 0) document.documentElement.classList.remove("dialog-open");
  };
}
